import React from 'react';
import {
  Button, Modal, Typography, Input, Space, Form,
} from 'antd';
import { useTranslation } from 'react-i18next';

import useRecoveryPassword from './useRecoveryPassword';

const { Paragraph } = Typography;

const RecoveryPassword = () => {

  const {
    visible, setVisible, loading, form, onOk,
  } = useRecoveryPassword();
  const { t } = useTranslation();

  return (
    <>
      <Button type="link" onClick={() => setVisible(!visible)}>
        {t('forms.login.buttons.remember_password')}
      </Button>
      <Modal
        // title={t('forms.login.buttons.remember_password')}
        title={t('forms.login.buttons.remember_password')}
        visible={visible}
        confirmLoading={loading}
        onOk={onOk}
        onCancel={() => setVisible(false)}
      >
        <Form form={form}>
          <Space direction="vertical" size="large">
            <Paragraph>
              {t('forms.recovery_password.paragraph.1')}
              {t('forms.recovery_password.paragraph.2')}
            </Paragraph>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: t('forms.recovery_password.feedbacks.email_req') },
                { type: 'email', message: t('forms.recovery_password.feedbacks.email_valid') },
              ]}
            >
              <Input
                size="large"
                type="email"
                placeholder={t('forms.recovery_password.email_placeholder')}
              />
            </Form.Item>
          </Space>
        </Form>
      </Modal>
    </>
  );

};

export default RecoveryPassword;
